type ThingKey = string;

export type RepaintOptions = {
  widgetIds?: string[];
  /** When true, consumers should rebuild jsPlumb connections based on current state */
  rebuildConnections?: boolean;
};

type RepaintFn = (opts?: RepaintOptions) => void;

const makeKey = (recipePoolId: string, thingId: string): ThingKey => `${recipePoolId}:${thingId}`;

const registry = new Map<ThingKey, RepaintFn>();
const rafQueue = new Map<ThingKey, { fn: RepaintFn; opts?: RepaintOptions }>();

const register = (recipePoolId: string, thingId: string, fn: RepaintFn): void => {
  registry.set(makeKey(recipePoolId, thingId), fn);
};

const unregister = (recipePoolId: string, thingId: string): void => {
  registry.delete(makeKey(recipePoolId, thingId));
};

const repaint = (recipePoolId: string, thingId: string, opts?: RepaintOptions): void => {
  const key = makeKey(recipePoolId, thingId);
  const fn = registry.get(key);
  if (!fn) { return; }

  // Coalesce per frame
  rafQueue.set(key, { fn, opts });
  if (rafQueue.size === 1) {
    requestAnimationFrame(() => {
      const batch = Array.from(rafQueue.values());
      rafQueue.clear();
      for (const item of batch) {
        try { 
          item.fn(item.opts); 
        } catch (e) { 
          /* eslint-disable no-console */ 
          console.error('[PortsRepaintRegistry] repaint error', e); 
        }
      }
    });
  }
};

const portsRepaintRegistry = { register, unregister, repaint };
export default portsRepaintRegistry;


